import { HpCompleteComponentV10 } from 'api3';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, computed, input, model } from '@angular/core';
import { HPDiagnosisQuestionComponent } from '../question/question.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { AccordionModule } from 'primeng/accordion';

@Component({
  selector: 'app-steps',
  imports: [CommonModule, TranslocoPipe, AccordionModule, HPDiagnosisQuestionComponent],
  template: `
    <p-accordion [(value)]="activeStep" class="qoverflow-x-hidden md:absolute md:inset-0">
      @for (step of completeComponentData()?.diagnosisSteps?.[0]?.diagnosisSteps; track $index) {
        <p-accordion-panel [value]="$index">
          <p-accordion-header class="">
            <span class="font-semibold text-black">{{ $index + 1 }}: {{ step.title?.trim() }}</span>
          </p-accordion-header>
          <p-accordion-content class="">
            <app-hp-diagnosis-question
              [diagnosticStep]="step"
              [isLastStep]="stepsCount() - 1 === $index"
              [isOpened]="activeStep() === $index"
              [svgComponent]="svgComponent"
              (onFinished)="onFinish.emit()"
              class="block" />
          </p-accordion-content>
        </p-accordion-panel>
      }

      <!-- No steps available -->
      @if (
        !completeComponentData()?.diagnosisSteps?.[0] ||
        !completeComponentData()?.diagnosisSteps?.[0]?.diagnosisSteps ||
        !(completeComponentData()?.diagnosisSteps?.[0]?.diagnosisSteps ?? []).length
      ) {
        <p-accordion-panel [value]="-1" [disabled]="true">
          <p-accordion-header class="">
            <ng-template #toggleicon let-active="active">
              <i class="pi pi-info text-gray-600"></i>
            </ng-template>

            {{ 'diagnosis.notAvailable' | transloco }}
          </p-accordion-header>
        </p-accordion-panel>
      }
    </p-accordion>
  `,
  standalone: true,
})
export class StepsComponent {
  activeStep = model.required<number>();
  completeComponentData = input<HpCompleteComponentV10 | undefined>();
  @Input() svgComponent: any;
  @Output() onFinish = new EventEmitter<void>();

  stepsCount = computed<number>(() => this.completeComponentData()?.diagnosisSteps?.[0]?.diagnosisSteps?.length || 0);
}
